import React from "react";
import { Container, Box, Typography } from "@mui/material";
import Resume from "../components/Resume/Resume";

const ResumePage = () => {
  return (
    <Box sx={{ pt: 4 }}>
      <Container maxWidth="lg">
        <Box sx={{ py: 4 }}>
          <Typography
            variant="h1"
            sx={{
              mb: 1,
              fontSize: { xs: "2.4rem", md: "3.5rem" },
              background: "linear-gradient(135deg, #2563eb, #7c3aed)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Resume
          </Typography>
          <Typography color="text.secondary" sx={{ maxWidth: 760 }}>
            A professional web version of your CV with direct download support.
          </Typography>
        </Box>

        <Resume />
      </Container>
    </Box>
  );
};

export default ResumePage;
